import { MdTypography, MdButton, MdIconAdd, MdModal } from '@antiqua-dls/vue-components';

export default {
    name: 'HeaderInventoryIngestionHub',
    components: {
        MdTypography,
        MdButton,
        MdIconAdd,
        MdModal
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        buttonText: {
            type: String,
            default: ''
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    emits: ['on-open-modal'],
    setup(props, { emit }) {
        const emitModal = () => {
            emit('on-open-modal', true)
        }

        return {
            emitModal
        }
    }
}